import moment from 'moment';

const global = window;

inputs.fn.table = {
    /**
     * Nettoie une chaîne de caractères pour la comparaison texte
     */
    cleanString(val) {
        if (val === null || val === undefined) return '';
        return String(val).trim().toLowerCase();
    },

    /**
     * Extrait une valeur numérique depuis une chaîne (supporte devises, % et espaces)
     */
    parseNumeric(val) {
        if (val === null || val === undefined) return 0;
        if (typeof val === 'number') return val;
        let str = String(val).replace(/\s/g, '').replace(/,/g, '.').replace(/[^0-9.-]/g, '');
        let num = parseFloat(str);
        return isNaN(num) ? 0 : num;
    },

    /**
     * Extrait un timestamp depuis une date
     */
    parseDate(val) {
        if (!val) return 0;
        let m = moment(val);
        return m.isValid() ? m.valueOf() : 0;
    },

    /**
     * Récupère le nom identifiant du tableau
     */
    getTableName($table) {
        return $table.attr('name') || $table.attr('id') || null;
    },

    /**
     * Sauvegarde l'état du tri pour une table
     */
    saveSortState(tableName, colIdentifier, order, sortType) {
        if (!tableName) return;
        try {
            let storageKey = 'tablesort_' + tableName;
            let data = JSON.stringify({ colIndex: colIdentifier, colIdentifier, order, sortType });
            if (window.localStorage) {
                localStorage.setItem(storageKey, data);
            } else {
                document.cookie = storageKey + '=' + encodeURIComponent(data) + '; path=/; max-age=31536000';
            }
        } catch (e) {}
    },

    /**
     * Récupère l'état sauvegardé du tri pour une table
     */
    getSortState(tableName) {
        if (!tableName) return null;
        try {
            let storageKey = 'tablesort_' + tableName;
            let dataStr = null;
            if (window.localStorage) {
                dataStr = localStorage.getItem(storageKey);
            }
            if (!dataStr) {
                let match = document.cookie.match(new RegExp('(^|;\\s*)' + storageKey + '=([^;]*)'));
                if (match) dataStr = decodeURIComponent(match[2]);
            }
            if (dataStr) {
                return JSON.parse(dataStr);
            }
        } catch (e) {}
        return null;
    },

    /**
     * Trie les lignes d'un tableau HTML en préservant le partitionnement par TableTitle
     * @param {jQuery|HTMLElement} tableElement Le tableau ou le conteneur du tableau
     * @param {number|string} colTarget L'index ou le nom (data-name) de la colonne ciblée
     * @param {string} sortType Type de tri ('text'|'string'|'numeric'|'number'|'date'|'html'|true)
     * @param {string} order 'asc' ou 'desc' (optionnel, alterne sinon)
     * @param {boolean} persist Sauvegarder dans le localStorage si la table a un nom
     */
    sort(tableElement, colTarget, sortType = 'text', order = null, persist = true) {
        let $table = $(tableElement).is('table') ? $(tableElement) : $(tableElement).find('table').first();
        if (!$table.length) return;

        let $thead = $table.find('> thead');
        let $tbody = $table.find('> tbody');

        // Trouver le th/td correspondant dans l'en-tête
        let $th = $();
        if (typeof colTarget === 'string' && isNaN(colTarget)) {
            $th = $thead.find('[data-name="' + colTarget + '"]').first();
        }
        if (!$th.length) {
            let idx = parseInt(colTarget, 10);
            if (!isNaN(idx) && idx >= 0) {
                let $sortables = $thead.find('th, td').filter('[data-sortable="true"], .table__col--sortable');
                if ($sortables.eq(idx).length) {
                    $th = $sortables.eq(idx);
                } else {
                    $th = $thead.find('th').eq(idx);
                }
            }
        }

        let colName = $th.length ? ($th.attr('data-name') || $th.data('name')) : (typeof colTarget === 'string' && isNaN(colTarget) ? colTarget : null);

        // Déterminer le sens du tri
        let currentOrder = $th.length ? $th.attr('data-sort-order') : null;
        let nextOrder = order || (currentOrder === 'asc' ? 'desc' : 'asc');

        // Mettre à jour les attributs et classes sur l'en-tête
        $thead.find('th, td').removeAttr('data-sort-order').removeClass('table__col--sort-asc table__col--sort-desc');
        if ($th.length) {
            $th.attr('data-sort-order', nextOrder).addClass(nextOrder === 'asc' ? 'table__col--sort-asc' : 'table__col--sort-desc');
        }

        // Sauvegarde de l'état si un nom de table est présent
        let tableName = inputs.fn.table.getTableName($table);
        if (persist && tableName) {
            inputs.fn.table.saveSortState(tableName, colName || colTarget, nextOrder, sortType);
        }

        // Récupérer les lignes normales partitionnées par section (délimitées par les TableTitle et TableFooter)
        let $allRows = $tbody.find('> tr');
        let sections = [];
        let currentSection = { title: null, rows: [], footer: null };
        sections.push(currentSection);

        function isSectionTitleRow($row) {
            return $row.hasClass('table__row--title') ||
                   $row.hasClass('sectionTR') ||
                   $row.hasClass('tableTitle') ||
                   $row.find('> td.table__title').length > 0 ||
                   ($row.hasClass('title') && ($row.find('> td[colspan]').length > 0 || !$row.find('> td').eq(1).length));
        }

        function isSectionFooterRow($row) {
            return $row.hasClass('table__row--footer') ||
                   $row.hasClass('table__row--total') ||
                   $row.hasClass('table__row--fixed-bottom') ||
                   $row.hasClass('table__row--bottom') ||
                   $row.hasClass('tableFooter');
        }

        $allRows.each(function () {
            let $row = $(this);

            if (isSectionTitleRow($row)) {
                // Nouvelle section délimitée par ce TableTitle
                currentSection = { title: $row, rows: [], footer: null };
                sections.push(currentSection);
            } else if (isSectionFooterRow($row)) {
                // Rangée de total / footer qui coupe le tri (ou termine la section courante)
                currentSection.footer = $row;
                currentSection = { title: null, rows: [], footer: null };
                sections.push(currentSection);
            } else {
                // Récupérer la cellule de la colonne ciblée
                let $cell;
                if (colName) {
                    $cell = $row.find('> td[data-name="' + colName + '"]');
                    if (!$cell.length) {
                        $cell = $row.find('> td.' + colName);
                    }
                }
                if (!$cell || !$cell.length) {
                    let idx = parseInt(colTarget, 10);
                    if (!isNaN(idx) && idx >= 0) {
                        $cell = $row.find('> td').eq(idx);
                    }
                }

                let sortVal;
                if ($cell && $cell.length) {
                    let sortAttr = $cell.attr('data-sort') ?? $cell.attr('sort') ?? $cell.attr('data-value') ?? $cell.attr('value');
                    if (sortAttr !== undefined && sortAttr !== null && sortAttr !== 'true' && sortAttr !== true) {
                        sortVal = sortAttr;
                    } else if ($cell.data('sort') !== undefined && $cell.data('sort') !== null && typeof $cell.data('sort') !== 'boolean') {
                        sortVal = $cell.data('sort');
                    } else if ($cell.data('value') !== undefined && $cell.data('value') !== null && typeof $cell.data('value') !== 'boolean') {
                        sortVal = $cell.data('value');
                    } else {
                        sortVal = $cell.text();
                    }
                } else {
                    sortVal = '';
                }

                currentSection.rows.push({
                    element: $row,
                    value: sortVal
                });
            }
        });

        // Normalisation du type de tri
        let type = typeof sortType === 'string' ? sortType.toLowerCase() : 'text';
        if (type === '1' || type === 'true') type = 'text';

        // Tri des lignes au sein de chaque section séparément (les sections entre titres/footers ne sont jamais mélangées)
        let comparator = function (a, b) {
            let valA = a.value;
            let valB = b.value;

            let cmp = 0;
            switch (type) {
                case 'numeric':
                case 'number':
                case 'int':
                case 'float':
                case 'money':
                case 'currency':
                    let numA = inputs.fn.table.parseNumeric(valA);
                    let numB = inputs.fn.table.parseNumeric(valB);
                    cmp = numA - numB;
                    break;

                case 'date':
                case 'time':
                case 'datetime':
                    let dateA = inputs.fn.table.parseDate(valA);
                    let dateB = inputs.fn.table.parseDate(valB);
                    cmp = dateA - dateB;
                    break;

                case 'text':
                case 'string':
                default:
                    let strA = inputs.fn.table.cleanString(valA);
                    let strB = inputs.fn.table.cleanString(valB);
                    cmp = strA.localeCompare(strB, 'fr', { numeric: true, sensitivity: 'base' });
                    break;
            }

            return nextOrder === 'desc' ? -cmp : cmp;
        };

        for (let section of sections) {
            if (section.rows && section.rows.length > 1) {
                section.rows.sort(comparator);
            }
        }

        // Réinjecter les lignes triées dans le tbody en conservant la structure des sections délimitées par TableTitle et TableFooter
        let docFragment = document.createDocumentFragment();
        for (let section of sections) {
            if (section.title) {
                docFragment.appendChild(section.title.get(0));
            }
            for (let item of section.rows) {
                docFragment.appendChild(item.element.get(0));
            }
            if (section.footer) {
                docFragment.appendChild(section.footer.get(0));
            }
        }
        $tbody.get(0).appendChild(docFragment);

        // Déclencher un événement personnalisé
        $table.trigger('table:sorted', [colTarget, nextOrder, sortType]);
    },

    /**
     * Initialise une table individuelle
     */
    init(table, data = {}) {
        let $table = $(table).is('table') ? $(table) : $(table).find('table').first();
        if (!$table.length) return;

        // Si la table est déjà initialisée
        if ($table.data('sort-initialized')) return;
        $table.data('sort-initialized', true);

        // 1. Attacher le clic sur les en-têtes triables (délégation d'événements pour dynamisme)
        $table.on('click', 'th.table__col--sortable, th[data-sortable="true"], td.table__col--sortable, td[data-sortable="true"]', function (e) {
            if ($(e.target).is('a, button, input, select, .btn')) return;

            let $th = $(this);
            let colName = $th.attr('data-name') || $th.data('name');
            let sortType = $th.attr('data-sort-type') || $th.data('sort-type') || 'text';

            let colIdentifier = colName;
            if (!colIdentifier) {
                colIdentifier = $th.parent().children().index($th);
            }

            inputs.fn.table.sort($table, colIdentifier, sortType, null, true);
        });

        // Apparence curseur pointer et title sur les colonnes triables
        $table.find('th.table__col--sortable, th[data-sortable="true"], td.table__col--sortable, td[data-sortable="true"]').each(function () {
            let $th = $(this);
            $th.css('cursor', 'pointer');
            if (!$th.attr('title')) $th.attr('title', 'Cliquer pour trier');
        });

        // 2. Déterminer quel tri appliquer au chargement
        let tableName = inputs.fn.table.getTableName($table);
        let savedState = tableName ? inputs.fn.table.getSortState(tableName) : null;

        if (savedState && (savedState.colIndex !== undefined || savedState.colIdentifier !== undefined)) {
            // A. Restaurer depuis le localStorage / cookie si présent
            let colId = savedState.colIdentifier !== undefined ? savedState.colIdentifier : savedState.colIndex;
            let $targetTh;
            if (typeof colId === 'string' && isNaN(colId)) {
                $targetTh = $table.find('> thead [data-name="' + colId + '"]').first();
            } else {
                $targetTh = $table.find('> thead th, > thead td').filter('[data-sortable="true"], .table__col--sortable').eq(colId);
                if (!$targetTh.length) {
                    $targetTh = $table.find('> thead th').eq(colId);
                }
            }
            if ($targetTh.length && ($targetTh.attr('data-sortable') === 'true' || $targetTh.hasClass('table__col--sortable'))) {
                let sortType = savedState.sortType || $targetTh.attr('data-sort-type') || 'text';
                inputs.fn.table.sort($table, colId, sortType, savedState.order, false);
            }
        } else {
            // B. Tri par défaut défini sur le table (data.sort ou attribut data-sort du <table>)
            let defaultSort = data.sort || $table.attr('data-sort') || $table.data('sort');
            if (defaultSort !== undefined && defaultSort !== null) {
                let colIdentifier = defaultSort;
                let sortOrder = 'asc';

                if (typeof defaultSort === 'string') {
                    let parts = defaultSort.trim().split(/\s+/);
                    colIdentifier = parts[0];
                    if (parts[1] && parts[1].toLowerCase() === 'desc') {
                        sortOrder = 'desc';
                    }
                }

                let $targetTh = $table.find('> thead [data-name="' + colIdentifier + '"]').first();
                if (!$targetTh.length && !isNaN(colIdentifier)) {
                    let idx = parseInt(colIdentifier, 10);
                    $targetTh = $table.find('> thead th, > thead td').filter('[data-sortable="true"], .table__col--sortable').eq(idx);
                    if (!$targetTh.length) {
                        $targetTh = $table.find('> thead th').eq(idx);
                    }
                }

                if ($targetTh.length) {
                    let sortType = $targetTh.attr('data-sort-type') || $targetTh.data('sort-type') || 'text';
                    inputs.fn.table.sort($table, colIdentifier, sortType, sortOrder, false);
                }
            }
        }
    },

    /**
     * Initialise toutes les tables dans un sélecteur/contexte
     */
    initAll(targetSelector) {
        let $root = targetSelector ? $(targetSelector) : $(document);
        $root.find('table.table, table.tableauAlterne, table:has(th.table__col--sortable), table:has(th[data-sortable="true"])').each(function () {
            inputs.fn.table.init(this);
        });
    },

    /**
     * Recalcule automatiquement les totaux des tables disposant de cellules de totaux
     */
    recalculateTotals(tableElement) {
        let $table = $(tableElement).is('table') ? $(tableElement) : $(tableElement).find('table').first();
        if (!$table.length) return;

        let totalPretFacturer = 0;
        let hasPretFacturer = false;

        $table.find('tbody tr:not(:last-child), tr.whiteTR:not(:last-child)').each(function () {
            let $cell = $(this).find('.pret_facturer');
            if ($cell.length) {
                hasPretFacturer = true;
                let text = $cell.text().trim();
                let val = inputs.fn.table.parseNumeric(text);
                if (!isNaN(val)) {
                    totalPretFacturer += val;
                }
            }
        });

        if (hasPretFacturer) {
            let $lastRow = $table.find('tr:last');
            let $totalCell = $lastRow.find('.pret_facturer, td:last');
            if ($totalCell.length) {
                let formatted = (typeof formatMoney === 'function') ? formatMoney(totalPretFacturer) : ((Math.floor(totalPretFacturer * 100) / 100) + ' $');
                $totalCell.html('<strong>' + formatted + '</strong>');
            }
        }
    }
};

// Aliases globaux rétrocompatibles
global.sortTable = inputs.fn.table.sort;
global.initSortableTables = inputs.fn.table.initAll;

// Écoute de rechargement automatique de rangée pour recalcul des totaux
$(document).on('row:reloaded', 'table', function () {
    inputs.fn.table.recalculateTotals(this);
});

// Définition de l'input type table dans le form builder
inputs.types.table = function (data, name, niceName, type, input, parent, inputWindow) {
    inputs.fn.table.init(input, data);
    return data;
};

// Initialisation globale via BEHAV
if (typeof BEHAV !== 'undefined' && BEHAV.add) {
    BEHAV.add(inputs.fn.table.initAll);
} else {
    $(function () {
        inputs.fn.table.initAll();
    });
}
